import React, { useState, useEffect } from 'react';
import { Table, TableBody, td, TableContainer, TableHead, tr, Button, IconButton, Paper } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { getPlacedStudents } from '../../services/getAllApi';
import { createPlacedStudents, deletePlacedStudents, updatePlacedStudents } from '../../services/getAdminApi';
import '../../styles/AdminGeneral.css';

const AddPlacedStudents = () => {

    const [placedStudents, setPlacedStudents] = useState([]);
    const [formData, setFormData] = useState({
        student_name: '',
        student_photo: null,
        company_logo: null,
        status: '1',
    });
    const [fileName, setFileName] = useState({
        student_photo: '',
        company_logo: '',
    });
    const [editingId, setEditingId] = useState(null);

    const fetchPlacedStudents = async () => {
        try {
            const response = await getPlacedStudents();
            setPlacedStudents(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            Swal.fire('Error', 'Failed to fetch placed students', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            setFormData({
                ...formData,
                [name]: files[0],
            });
            setFileName({
                ...fileName,
                [name]: files[0].name, // Update the file name state when a file is selected
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSave = async () => {
        if (!formData.student_name) {
            Swal.fire('Validation Error', 'Please fill all required fields', 'error');
            return;
        }

        const payload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value) payload.append(key, value);
        });

        try {
            if (editingId !== null) {
                const confirmEdit = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'Do you want to update this student?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, update it!',
                });

                if (confirmEdit.isConfirmed) {
                    console.log("placed",formData)
                    await updatePlacedStudents(editingId, formData).then((res)=>{
                        console.log(res)
                        if(res.status===200){
                            Swal.fire('Success', 'Student updated successfully', 'success');
                        }
                    })
                  
                }
            } else {
                await createPlacedStudents(payload).then((res)=>{
                    if(res.status===201){
                        Swal.fire('Success', 'Student added successfully', 'success');
                    }
                })
               
            }

            setFormData({
                student_name: '',
                student_photo: null,
                company_logo: null,
                status: '1',
            });
            setFileName({
                student_photo: '',
                company_logo: '',
            });
            setEditingId(null);
            document.getElementById("file-upload").value = "";
            document.getElementById("company-logo").value = "";
            fetchPlacedStudents();
        } catch (error) {
            Swal.fire('Error', 'Failed to save student', 'error');
        }
    };

    const handleEdit = (student) => {
        setEditingId(student.id);
        setFormData({
            student_name: student.student_name,
            student_photo: student.student_photo,
            company_logo: student.company_logo,
            status: student.status,
        });
        setFileName({
            student_photo: student.student_photo.slice(-10),
            company_logo: student.company_logo.slice(-10),
        });
    };

    const handleDelete = async (id) => {
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will delete the student permanently!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        });

        if (confirmDelete.isConfirmed) {
            try {
                await deletePlacedStudents(id).then((res) => {
                    if (res.status === 200) {
                        Swal.fire('Success', 'Student deleted successfully', 'success');
                    }
                })

                fetchPlacedStudents();
            } catch (error) {
                Swal.fire('Error', 'Failed to delete student', 'error');
            }
        }
    };

    useEffect(() => {
        fetchPlacedStudents();
    }, []);

    return (
        <div>
            <div className="dashboard-heading-div">
                <p>Manage Placed Students</p>
            </div>

            <div className='editing-container'>
                <div>
                    <h2 className='editing-container-heading'>{editingId !== null ? 'Edit Placed Student' : 'Create Placed Student'}</h2>

                    <div className="editing-container-form">
                        <div className='editing-container-input-div'>
                            <label>Student Name: </label>
                            <input
                                name="student_name"
                                value={formData.student_name}
                                onChange={handleInputChange}
                                required
                                placeholder='Enter Student Name'
                            />
                        </div>

                        <div className='editing-container-input-div'>
                            <label>Student Photo:</label>
                            <label htmlFor="file-upload" className="file-upload-btn">
                                <i class='bx bx-cloud-upload' ></i>  {fileName.student_photo || ' Choose File'}
                            </label>
                            <input
                                className="file-upload"
                                id="file-upload"
                                type="file"
                                name="student_photo"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className='editing-container-input-div'>
                            <label>Company Logo:</label>
                            <label htmlFor="company-logo" className="file-upload-btn">
                                <i class='bx bx-cloud-upload' ></i>  {fileName.company_logo || ' Choose File'}
                            </label>
                            <input
                                className="file-upload"
                                id="company-logo"
                                type="file"
                                name="company_logo"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                        </div>

                    </div>
                </div>
                <button variant="contained" color="primary" onClick={handleSave}>

                    {editingId !== null ? 'Update' : 'SAVE'} <i class='bx bx-send' ></i>
                </button>
            </div>


            <div className='table-container-registered-students'>

                <table>
                    <thead>
                        <tr>
                            <th>Student Name</th>
                            <th>Student Photo</th>
                            <th>Company Logo</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {placedStudents.map((student) => (
                            <tr key={student.id}>
                                <td>{student.student_name}</td>
                                <td>
                                    {student.student_photo && (
                                        <img
                                            src={`${"https://console.fbsedu.in/storage/app/"}/${student.student_photo}`}
                                            alt="Student Photo"
                                            style={{ width: 50, height: 50 }}
                                        />
                                    )}
                                </td>
                                <td>
                                    {student.company_logo && (
                                        <img
                                            src={`${"https://console.fbsedu.in/storage/app/"}/${student.company_logo}`}
                                            alt="Company Logo"
                                            style={{ width: 50, height: 50 }}
                                        />
                                    )}
                                </td>
                                <td>
                                    {/* <IconButton color="secondary" onClick={() => handleEdit(student)}>
                                        <Edit />
                                    </IconButton> */}
                                    <IconButton color="error" onClick={() => handleDelete(student.id)}>
                                        <Delete />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default AddPlacedStudents;
